import application from 'application/application';

import template from './forgot-password.template.html';

import controller from './forgot-password.controller';

application

	.config(['$stateProvider', $stateProvider => {

		$stateProvider

			.state('root.forgotPassword', {
				url: '/esqueci-minha-senha',
				views: {
					'root': {
						templateUrl: template,
						controller
					}
				},
				data: {
					documentTitle: 'Esqueci Minha Senha'
				}
			});

	}]);
